import {
  Card, CardContent, CircularProgress, Divider,
} from '@material-ui/core';
import IconButton from '@material-ui/core/IconButton';
import { StyleRules, withStyles } from '@material-ui/core/styles';
import CloseIcon from '@material-ui/icons/Close';
import i18next from 'i18next';
import * as React from 'react';
import { Component } from 'react';
import ReactMarkdown from 'react-markdown';
import { Link } from 'react-router-dom';
import JurisdictionSpecificInfoType from '../models/JurisdictionSpecificInfo';
import ARHttp from '../services/ARHttp';
import getLocale from '../services/getLocaleService';
import convertImages from '../services/ImageCoverter';
import isEmpty from '../services/IsEmpty';
import { getStore } from '../services/StoreService';

const styles: StyleRules = {
  subText: {
    margin: '8px 0',
    color: '#FFFFFF',
  },
  subTextDynamic: {
    margin: '8px 0',
    color: '#000000',
  },
  headerText: {
    fontSize: '24px',
    margin: '8px 0',
    color: '#FFFFFF',
  },
  largeText: {
    margin: '8px 0',
  },
  dividerColor: {
    color: '#FFFFFF',
    backgroundColor: '#FFFFFF',
  },
  contactBoxColor: {
    color: '#377CAB',
    backgroundColor: '#377CAB',
  },
  contactBoxColorDynamic: {
    color: '#FFFFFF',
    backgroundColor: '#FFFFFF',
  },
  jurisdictionLogo: {
    padding: '8px',
    maxHeight: '75px',
    maxWidth: '215px',
  },
};

const sanPolLogo = convertImages(require('../assets/images/SanPol.png'));

// TODO: Investigate console error.
class ContactUs extends Component<any, any> {
  constructor(props) {
    super(props);
    this.state = {
      dataRetrived: false,
      markdowntext: null,
    };
  }

  public componentDidMount() {
    let subJurisdictionCode;
    if (getStore()) {
      if (isEmpty(this.props.subJurisdiction)) {
        subJurisdictionCode = getStore().getState().JurisdictionInfo.subJurisdictionCode;
      }
    }

    let uri;
    if (isEmpty(this.props.contactInfoUri)) {
      uri = '/sb/lookup/getJurisdictionInfo';
    }

    ARHttp({
      method: 'POST',
      url: this.props.contactInfoUri || uri,
      body: {
        subJurisdiction: this.props.subJurisdiction || subJurisdictionCode,
        infoType: JurisdictionSpecificInfoType.CONTACT_US_MAIN,
        language: this.props.locale || getLocale(),
      },
    }).subscribe(
      (response: any) => {
        this.setState({
          dataRetrived: true,
          markdowntext: response.info,
        });
      },
      () => {
        this.setState({
          ...this.state,
          dataRetrived: true,
          markdowntext: undefined,
        });
      },
    );
  }

  public render() {
    // istanbul ignore next
    let contactHeader;
    let contactNumber;
    let jurisdictionLogoImage;
    let salesAssist = i18next.t('for_sales_assist_subtext');
    let contactHours = i18next.t('elavon_phone_assist_hours');
    let origin;

    const classes = this.props.classes!;
    let country: string | undefined;
    if (getStore()) {
      country = getStore().getState().JurisdictionInfo.country;
    }

    if (this.props.location && this.props.location.state && this.props.location.state.header) {
      contactHeader = this.props.location.state.header;
    } else {
      contactHeader = i18next.t('contact_us');
    }
    if (this.props.location && this.props.location.state && this.props.location.state.number) {
      contactNumber = this.props.location.state.number;
    } else {
      contactNumber = i18next.t('contact_us_number');
      if (country === 'GBR') {
        contactNumber = i18next.t('contact_us_number_gb');
        contactHours = i18next.t('elavon_phone_assist_hours_gb');
      }
    }

    if (this.props.location && this.props.location.state && this.props.location.state.origin) {
      origin = this.props.location.state.origin;
    }

    if (this.props.jurisdiction) {
      if (this.props.jurisdiction === 'SBCSTCUSA' || this.props.jurisdiction === 'SELF_BOARD_COSTCO_USA') {
        contactNumber = '1-866-930-0524';
        contactHours = 'Mon-Fri: 9:00 AM - 8:00 PM EST';
      }
      if (this.props.jurisdiction === 'SBSANPL' || this.props.jurisdiction === 'SELF_BOARD_SAN_POL') {
        contactNumber = i18next.t('contact_us_number_san_pol');
        contactHours = i18next.t('elavon_phone_assist_hours_san_pol');
        salesAssist = i18next.t('for_sales_assist_subtext_san_pol');
        jurisdictionLogoImage = <img src={sanPolLogo} alt="icon" className={classes.jurisdictionLogo} />;
      }
    }

    function renderImage(props) {
      return <img alt="icon" src={props.src} className={classes.jurisdictionLogo} />;
    }

    function renderText(props) {
      return <p className={classes.subTextDynamic}>{props.children}</p>;
    }

    const closeModal = this.props.onClose!;

    function renderHeading(values) {
      return (
        <div id="contactHeader" className={classes.headerText}>
          {values.children}
          {closeModal ? (
            <IconButton
              aria-label="Close"
              onClick={closeModal}
              style={{ float: 'right', padding: '0px', marginTop: '-45px' }}
            >
              <CloseIcon />
            </IconButton>
          ) : null}
        </div>
      );
    }
    if (this.state.dataRetrived) {
      if (this.state.markdowntext) {
        return (
          <Card style={{ marginTop: '16px' }} role="complementary">
            <CardContent className={classes.contactBoxColorDynamic}>
              {origin && (
                <Link
                  to={{
                    pathname: origin.pathname,
                  }}
                  style={{ height: '50px', lineHeight: '50px' }}
                >
                  {origin.name}
                </Link>
              )}
              {this.props.onClose ? (
                <IconButton
                  aria-label="Close"
                  onClick={this.props.onClose}
                  style={{
                    float: 'right',
                    padding: '0px',
                  }}
                >
                  <CloseIcon />
                </IconButton>
              ) : null}
              <ReactMarkdown
                source={this.state.markdowntext}
                renderers={{ strong: renderHeading, image: renderImage, text: renderText }}
              />
            </CardContent>
          </Card>
        );
      }
      return (
        <Card style={{ marginTop: '16px' }}>
          <CardContent className={classes.contactBoxColor}>
            {origin && (
              <Link
                to={{
                  pathname: origin.pathname,
                }}
                style={{ height: '50px', lineHeight: '50px' }}
              >
                {origin.name}
              </Link>
            )}
            <p id="contactHeader" className={classes.headerText}>
              {contactHeader}
              {this.props.onClose ? (
                <IconButton aria-label="Close" onClick={this.props.onClose} style={{ float: 'right', padding: '0px' }}>
                  <CloseIcon />
                </IconButton>
              ) : null}
            </p>
            <Divider className={classes.dividerColor} />
            <p className={classes.subText}>{salesAssist}</p>
            <p id="contactNumber" className={classes.subText}>
              {contactNumber}
            </p>
            <p id="contactHours" className={classes.subText}>{contactHours}</p>
            {jurisdictionLogoImage}
          </CardContent>
        </Card>
      );
    }
    return (
      <Card style={{ marginTop: '16px' }}>
        <CardContent className={classes.contactBoxColor}>
          <p id="contactHeader" className={classes.headerText}>
            {this.props.onClose ? (
              <IconButton aria-label="Close" onClick={this.props.onClose} style={{ float: 'right', padding: '0px' }}>
                <CloseIcon />
              </IconButton>
            ) : null}
          </p>
          <CircularProgress variant="indeterminate" size={30} className={classes.circularProgress} />
        </CardContent>
      </Card>
    );
  }
}

export default withStyles(styles)(ContactUs);
